import styled from "styled-components";

export const CurrentTitleSpan = styled.span`
  color: #22548a;
  font-size: 20px;
  font-weight: 600;
`;
